import * as actionTypes from "./actionTypes";
// import { coupons } from "../../data";
import { generateUniqueId } from ".././utility";
import { firebase } from "../../firebase/index";
import { collections, documents } from "../../firebase/firestoreNameSpaces";

export const onAddCoupon = (newCoupon) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.COUPON_CONTROLS,
      payload: { couponBtnLoading: true },
    });
    let db = firebase.firestore();

    db.collection(collections.K5METADATA)
      .doc(documents.COUPONS)
      .get()
      .then((snapshot) => {
        let coupons = snapshot.data();
        for (let ckey in coupons) {
          if (coupons[ckey].couponName == newCoupon.couponName) {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            return alert(
              "Coupon already exists. Please Select Different Coupon Name"
            );
          }
        }
        let couponId = generateUniqueId(Math.random() * 100000);
        newCoupon["couponId"] = couponId;
        db.collection(collections.K5METADATA)
          .doc(documents.COUPONS)
          .set(
            {
              [couponId]: newCoupon,
            },
            { merge: true }
          )
          .then(() => {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            window.location.reload();
          })
          .catch((err) => {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            return alert(err);
          });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { couponBtnLoading: false },
        });
        return alert(err);
      });
  };
};

export const onFetchCoupon = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.COUPON_CONTROLS,
      payload: { loading: true },
    });

    let db = firebase.firestore();

    db.collection(collections.K5METADATA)
      .doc(documents.COUPONS)
      .get()
      .then((snapshot) => {
        let coupons = [];
        let results = snapshot.data();

        for (let couponId in results) {
          coupons.push(results[couponId]);
        }

        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { coupons: coupons, loading: false },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { coupons: [], loading: false },
        });
        return alert(err);
      });
  };
};

export const onEditCoupon = (coupon, oldCouponArray) => {
  return (dispatch, getState) => {
   
    dispatch({
      type: actionTypes.COUPON_CONTROLS, 
      payload: { couponBtnLoading: true },
    });
    let couponId = coupon.id;

    let db = firebase.firestore();

    db.collection(collections.K5METADATA)
      .doc(documents.COUPONS)
      .get() 
      .then((snapshot) => {
        let coupons = snapshot.data();
        for (let ckey in coupons) {
          if (
            ckey != couponId &&
            coupons[ckey].couponName == coupon.couponName
          ) {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            return alert(
              "Coupon already exists. Please Select Different Coupon Name"
            );
          }
        }
        db.collection(collections.K5METADATA)
          .doc(documents.COUPONS)
          .set(
            {
              [couponId]: coupon,
            },
            { merge: true }
          )
          .then(() => {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            window.location.reload();
          })
          .catch((err) => {
            dispatch({
              type: actionTypes.COUPON_CONTROLS,
              payload: { couponBtnLoading: false },
            });
            return alert(err);
          });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { couponBtnLoading: false },
        });
        return alert(err);
      });
  };
};

export const onDeleteCoupon = (couponId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.COUPON_CONTROLS,
      payload: { deleteBtnLoading: true },
    });

    let db = firebase.firestore();

    db.collection(collections.K5METADATA)
      .doc(documents.COUPONS)
      .set(
        {
          [couponId]: firebase.firestore.FieldValue.delete(),
        },
        { merge: true }
      )
      .then(() => {
        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { deleteBtnLoading: false },
        });
        window.location.reload();
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.COUPON_CONTROLS,
          payload: { deleteBtnLoading: false },
        });
        return alert(err);
      });
  };
};
